import { render } from "./blog-tags.vue?vue&type=template&id=273815cf"
import script from "./blog-tags.vue?vue&type=script&lang=js"
export * from "./blog-tags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__